module.exports = __webpack_public_path__ + "static/learn-with-wersel-c89d4a1c196c8cea7eaa61cb38a34677.png";